<div id="employee-detail-wrapper" data-cy="employee-detail-wrapper">
  <p *ngIf="notFound" data-cy="employee-not-found">Employee not found.</p>

  <ep-employee-form-card
    *ngIf="employee && !notFound"
    [mode]="(mode$ | async)!"
    [isSaving]="isSaving"
    [isSaveDisabled]="(isSaveDisabled$ | async) === true"
    [showImpersonate]="true"
    [isImpersonating]="isImpersonating"
    (edit)="edit()"
    (cancel)="cancelEdit()"
    (save)="saveEmployee()"
    (impersonate)="impersonate()"
  >
    <app-employee-form></app-employee-form>
  </ep-employee-form-card>

  <p-confirmDialog
    data-cy="resend-welcome-email-dialog"
    styleClass="resend-welcome-dialog"
    [style]="{ width: '90vw', maxWidth: '800px' }"
  ></p-confirmDialog>
</div>
